import { singleton } from "tsyringe";
import webfont from "webfontloader";
import { EventBus } from "./event-bus";
import { PixiApp } from "./pixi-app";
import monet from "~/src/assets/monet.jpg";
import monetNormal from "~/src/assets/monet_normal.jpg";
import textDisp from "~/src/assets/text_disp.png";
import circle from "~/src/assets/circle.png";
import { paintingsData } from "./config/paintings";
import homeIcon from "~/src/assets/home_ic.png";
// import infoIcon from "~/src/assets/info_ic.png";
import bulbIcon from "~/src/assets/bulb_ic.png";
import moonIcon from "~/src/assets/moon_ic.png";

@singleton()
export class AssetsLoader {
  constructor(private pixiApp: PixiApp, private eventBus: EventBus) {}
  async load() {
    await Promise.all([this.loadFonts(), this.loadPixiAssets()]);
  }
  loadPainting(key: string): Promise<void> {
    return new Promise((res) => {
      const { loader } = this.pixiApp;
      const painting = paintingsData.find((p) => p.key === key);
      const mainKey = painting.key;
      const normalKey = painting.key + "normal";
      if (
        loader.resources[mainKey]?.isComplete &&
        loader.resources[normalKey]?.isComplete
      ) {
        return res();
      }
      document.body.classList.add("loading");
      loader.add(mainKey, painting.file);
      loader.add(normalKey, painting.normal);
      loader.load(() => {
        document.body.classList.remove("loading");
        res();
      });
    });
  }
  private loadPixiAssets() {
    return new Promise((res) => {
      Object.entries(assetsMap).forEach(([name, url]) => {
        if (!this.pixiApp.loader.resources[name]) {
          this.pixiApp.loader.add(name, url);
        }
      });
      this.pixiApp.loader.load(res);
    });
  }
  private loadFonts(): Promise<void> {
    return new Promise((res) => {
      setTimeout(() => {
        webfont.load({
          custom: {
            families: ["Playfair Display"],
          },
          active: res,
        });
      });
    });
  }
}

export const assetsMap = {
  monet,
  monetNormal,
  bulbIcon,
  textDisp,
  circle,
  homeIcon,
  // infoIcon,
  moonIcon,
  ...paintingsData.reduce(
    (acc, p) => ({
      ...acc,
      [p.key + "thumb"]: p.thumb,
    }),
    {}
  ),
};
export type TAssetName = keyof typeof assetsMap;
